export default __webpack_public_path__ + "static/media/CirculoDAPP_UNICEF-01.5cbd0c4c.svg";